import React from 'react';

/**
 * The form layout grid (KPE-023): the fields of ONE section, drawn on twelve
 * columns, by the entry form and the read view alike.
 *
 * Two elements, so the grid can answer to its own width:
 *   .form-grid         the wrapper — a size container (`container-type:
 *                      inline-size`), because an element cannot query a width
 *                      it also decides;
 *   .form-grid__cells  the grid itself, which takes the caller's `className`
 *                      (`item-form-fields`, `item-read__fields`), `id`,
 *                      `hidden` and any other prop.
 *
 * The width it answers to is the section's own field area, not the window:
 * the form beside the Attachments rail, a detail pane and a phone each get
 * the columns they have room for (css/components/form-grid.css has the three
 * tiers). Cells say how many columns they want at each of the first two
 * (`FormGridCell`); under the third every cell is the full row.
 */
export function FormGrid({ className = '', children, ...rest }) {
	return (
		<div className="form-grid">
			<div className={`form-grid__cells ${className}`.trim()} {...rest}>
				{children}
			</div>
		</div>
	);
}

/**
 * One element's cell. `wide` is its columns of 12 and `medium` its columns of
 * 6 (utils/formGridCells.cellSpans: already held to the element's type
 * limits). `newRow` starts it on a fresh row, wherever the previous cell
 * ended; it is ignored when the grid is one column.
 *
 * `data-half` marks a cell of half the row or less, which the detail pane's
 * Medium width pairs two to a row (KPR-1643, css/components/form-grid.css).
 */
export function FormGridCell({ wide = 12, medium = 6, newRow = false, className = '', style, children, ...rest }) {
	const classes = ['form-grid__cell', newRow ? 'form-grid__cell--new-row' : '', className].filter(Boolean).join(' ');
	return (
		<div className={classes} style={{ ...style, '--span': wide, '--span-md': medium }} data-half={wide <= 6 ? '' : undefined} {...rest}>
			{children}
		</div>
	);
}

export default FormGrid;
